import { createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { OrderDirection } from "../../external/ensolvers-core-frontend-mui/components/Common/GenericTable";
import TableBasedCrud from "../../external/ensolvers-core-frontend-mui/components/TableBaseCrud";
import Site from "../../models/Site";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import { useEffect } from "react";
import { useSiteList } from "../../hooks/useSiteList";
import OpsAvatarComponent from "../OpsAvatarComponent";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import icon from "../../img/icons/sites_icon.svg"
import OpsPanel from "../OpsPanel";

export const PriorityEnum = {
  HIGH: { icon: <KeyboardArrowUpIcon /> },
  MEDIUM: { icon: <HorizontalRuleIcon /> },
  LOW: { icon: <KeyboardArrowDownIcon /> },
} as const;

const COLUMN_GRID = 3;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    siteCard: {
      cursor: "pointer",
      height: "28em",
      margin: "0.5em 1.15em 1.15em 0",
    },
    siteCardContainer: {
      height: "62em",
      overflow: "auto",
      display: "flex",
      flexWrap: "wrap",
    },
    default: {
      overflow: "hidden",
      minHeight: "28em",
    },
    avatar: {
      "& img":{
        objectFit: "cover"
      }
    }
  }),
  { index: 1 },
);

export default function SitesTile() {
  const { t } = useTranslation();
  const { siteActions } = useSiteList();
  const classes = useStyles();

  useEffect(() => {
    siteActions.getRecommendedSites(0, 10);
  }, []);

  return (
    <>
      {siteActions.result !== undefined && siteActions.result > 0 && (
        <OpsPanel
          title="Recommended Sites"
          icon={icon}
        >
          <TableBasedCrud<Site>
            elementName={"Sites"}
            defaultSortDir={OrderDirection.ASC}
            stylesForHeader={{
              fontSize: "1.1em",
            }}
            onDataFetch={(pageNumber, count) => siteActions.getRecommendedSites(pageNumber, count)}
            hideActions
            renderDialogContent={() => <></>}
            showItemsAsCards
            useInfiniteScroll={false}
            cardItemSpec={{
              header: [
                {
                  content: () => (
                    <></>
                  ),
                },
              ],
              body: [
                {
                  content: (instance) => {
                    return (
                      <>
                        <OpsAvatarComponent
                          avatarUrl={instance.imageUrl}
                          forceGenericAvatar={true}
                          genericAvatar={<NoPhotographyIcon sx={{ width: "4em", height: "4em"}} />}
                          sx={{
                            height: "12em",
                            borderRadius: "15px",
                          }}
                          customClasses={classes.avatar}
                          customStyle={{ width: "100%", display: "flex", justifyContent: "center", margin: "auto"}}
                        />
                        <Typography style={{fontWeight: "bold", marginTop:"0.8rem"  }}>{instance.projectName.length > 0 ? instance.projectName + " - " + instance.title : instance.title}</Typography>
                      </>
                    );
                  },
                },
              ],
              footer: [
                {
                  content: (instance) => (
                    <>
                      {instance.description
                        ? instance.description.length > 100
                          ? instance.description.substring(0, 100).concat("...")
                          : instance.description
                        : ""}
                    </>
                  ),
                },
              ],
              onClick: (instance: any) => window.open(`${instance.link}`),
              customContainerStyles: siteActions.result > 12 / COLUMN_GRID ? `${classes.siteCardContainer}` : `${classes.default}`,
              customCardStyles: `${classes.siteCard}`,
              columnSize: COLUMN_GRID,
              multiItemPerRow: true,
            }}
            tableColumns={[
              {
                header: t("Image"),
                content: (instance) => (
                  <>
                    <OpsAvatarComponent
                      avatarUrl={instance.imageUrl}
                      forceGenericAvatar={true}
                      genericAvatar={<NoPhotographyIcon />}
                      sx={{ width: "2.5em", height: "2.5em" }}
                    />
                  </>
                ),
              },
              {
                header: t("Project"),
                content: (instance) => <>{instance.projectExternalId == "" ? "ALL" : instance.projectName}</>,
              },
              {
                header: t("Title"),
                content: (instance) => (
                  <>
                    <a href={`${instance.link}`} target={"_blank"} rel={"noopener noreferrer"}>
                      {instance.title}
                    </a>
                  </>
                ),
              },
              {
                header: t("Description"),
                content: (instance) => <>{instance.description == null ? "" : instance.description}</>,
              },
              {
                header: t("Priority"),
                content: (instance) => <>{PriorityEnum[instance.priority].icon}</>,
              },
            ]}
          />
        </OpsPanel>
      )}
    </>
  );
}
